const Widget = require("app/components/checkout/mixins/Widget");
const PropTypes = require("prop-types");
const Trans = require('app/components/trans/Trans')

class DiscountWidget extends Widget {

    static get propTypes() {
        return {
            value: PropTypes.string,
            error: PropTypes.string,
            onChange: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            value: "",
            error: null
        };
    }

    get title() {
        return translate("GAVEKORT / RABATKODE");
    }

    get className() {
        return super.className + " discount-widget";
    }

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            error: props.error
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error !== this.state.error) {
            this.setState({error: nextProps.error});
        }
    }

    onSubmit = (e) => {
        e.preventDefault();

        if (typeof this.props.onChange === "function") {
            this.props.onChange(this.inputElement.value);
        }
    };

    renderBody() {
        return (
            <form onSubmit={this.onSubmit}>
                <input type="text" ref={el => this.inputElement = el} defaultValue={this.state.value || ""}/>
                <button type="submit"><Trans>Indløs</Trans></button>
            </form>
        );
    }

    renderFooter() {
        if (this.state.error) {
            return (
                <div className="widget-error">{this.state.error}</div>
            );
        }
    }

}

module.exports = DiscountWidget;
